const STORAGE_KEY = 'listbright:recent-cities';
const MAX = 5;

export function getRecentCities(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((s): s is string => typeof s === 'string') : [];
  } catch {
    return [];
  }
}

export function pushRecentCity(city: string): void {
  const trimmed = city?.trim();
  if (!trimmed) return;
  try {
    const existing = getRecentCities().filter(c => c.toLowerCase() !== trimmed.toLowerCase());
    const next = [trimmed, ...existing].slice(0, MAX);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    /* ignore quota errors */
  }
}